import { useEffect, useState } from 'react';
import ZTM_API_BASE from '../services/ztmApi';

export default function useVehicleRoute(tripId, routeId, date) {
  const [coords, setCoords] = useState([]);

  useEffect(() => {
    if (!tripId || !routeId || !date) return;

    const fetchRoute = async () => {
      try {
        const url = `${ZTM_API_BASE}/shapes?date=${date}&routeId=${routeId}&tripId=${tripId}`;
        const response = await fetch(url);
        const data = await response.json();

        if (data?.coordinates) {
          const latlngs = data.coordinates.map(coord => [coord[1], coord[0]]);
          setCoords(latlngs);
        }
      } catch (error) {
        console.error('Błąd podczas pobierania trasy pojazdu:', error);
      }
    };

    fetchRoute();
  }, [tripId, routeId, date]);

  return coords;
}
